import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { Timeline } from '../../../core/services/cases.service';
import { MbCaseTimeLineSkeletonComponent } from '../mb-casetimeline-skeleton/mb-case-time-line-skeleton.component';
import { MbTimelineItemComponent } from '../mb-timeline-item/mb-timeline-item.component';

@Component({
  selector: 'app-mb-case-timeline',
  standalone: true,
  imports: [
    NgIf,
    NzTimelineModule,
    MbCaseTimeLineSkeletonComponent,
    MbTimelineItemComponent,
],
  templateUrl: './mb-case-timeline.component.html',
})
export class MbCaseTimelineComponent {
  @Input() timeline: Timeline[] = [];
  @Input() isLoading = false;
  @Input() organizationId: string | null = null;
  @Input() class = '';

  @Output() downloadDocument = new EventEmitter<{ type: string; url?: string }>();

  onDownloadDocument(document: { type: string; url?: string }): void {
    this.downloadDocument.emit(document);
  }
}

